export default {
    ADD_SUPPLIER(state, supplier) {
      state.suppliers.unshift(supplier);
      state.totalDataRow++;
    },
    SET_SUPPLIER(state, res) {
      state.suppliers = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_SUPPLIER(state, supplier) {
      const supplierIndex = state.suppliers.findIndex((p) => p.id == supplier.id)
      Object.assign(state.suppliers[supplierIndex], supplier)
    },
    REMOVE_SUPPLIER(state, supplierId) {
      const supplierIndex = state.suppliers.findIndex((p) => p.id == supplierId)
      state.suppliers.splice(supplierIndex, 1)
    },
  }
  